export { default as Logo } from './hocs';
